import api from './api';
import type {
  DadosPresencaAgendamentoContract,
  ConfirmarPresencaResponseContract,
  AgendamentoHistoricoItemContract,
} from '@sstexames/shared-types';

export const presencaService = {
  /**
   * Busca dados do agendamento para confirmação de presença
   */
  async getDados(token: string): Promise<DadosPresencaAgendamentoContract> {
    const response = await api.get<DadosPresencaAgendamentoContract>(
      `/presenca/${token}`,
    );
    return response.data;
  },

  /**
   * Momento 1: Confirma intenção de comparecer ("Pretendo ir")
   */
  async confirmarIntencao(token: string, horario?: string): Promise<ConfirmarPresencaResponseContract> {
    const response = await api.post<ConfirmarPresencaResponseContract>(
      `/presenca/${token}/intencao`,
      { horario },
    );
    return response.data;
  },

  /**
   * Registro de Presença com selfie
   */
  async comprovarPresenca(
    token: string,
    params: {
      file?: File | Blob;
      base64?: string;
      isMobile: boolean;
      horario?: string;
      tipoConfirmacao?: 'ja_chegou' | 'horario_previsto';
    },
  ): Promise<ConfirmarPresencaResponseContract> {
    if (params.file) {
      const formData = new FormData();
      formData.append('selfie', params.file, 'selfie.jpg');
      formData.append('is_mobile', String(params.isMobile));
      if (params.horario) formData.append('horario', params.horario);
      if (params.tipoConfirmacao) formData.append('tipo_confirmacao', params.tipoConfirmacao);

      const response = await api.post<ConfirmarPresencaResponseContract>(
        `/presenca/${token}/comprovar`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      return response.data;
    }

    const response = await api.post<ConfirmarPresencaResponseContract>(
      `/presenca/${token}/comprovar`,
      {
        selfie_base64: params.base64,
        is_mobile: params.isMobile,
        horario: params.horario,
        tipo_confirmacao: params.tipoConfirmacao,
      },
    );
    return response.data;
  },

  /**
   * Registra ausência informada ("Não vou comparecer")
   */
  async recusarPresenca(
    token: string,
    motivo?: string,
  ): Promise<ConfirmarPresencaResponseContract> {
    const response = await api.post<ConfirmarPresencaResponseContract>(
      `/presenca/${token}/recusar`,
      { motivo },
    );
    return response.data;
  },

  /**
   * Retorna o histórico de auditoria de status do agendamento
   */
  async getHistorico(agendamentoId: number): Promise<AgendamentoHistoricoItemContract[]> {
    const response = await api.get<AgendamentoHistoricoItemContract[]>(
      `/presenca/agendamento/${agendamentoId}/historico`,
    );
    return response.data;
  },

  /**
   * Obtém o blob binário da selfie de presença com autenticação
   */
  async getSelfieBlob(identifier: string | number): Promise<Blob> {
    const response = await api.get<Blob>(`/presenca/${identifier}/selfie`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
